export const VERIFYING = 'Verifying new file. Old prices remain active';
export const VERIFICATION_FAILED = 'Verification failed. Old prices remain active';
export const VERIFIED = 'New prices will replace current at 00:00';
export const REPLACEMENT_IN_PROGRESS = 'Replacement in progress';
export const REPLACEMENT_FAILED = 'Replacement failed';
export const DELETED='Pricebook will be deleted at 00:00';